import axios from "axios";
import { Dispatch } from "redux";
import { EditPatientImportConfigDataActionTypes } from "./ActionTypes";
import {
  EditPatientImportConfigDetailsBody,
  EditPatientImportConfigValueRes,
} from "./Model";
import {
  clearEditPatientImportConfigDataAPIRes,
  editPatientImportConfigDataErrorAction,
  editPatientImportConfigDataLoadingAction,
  editPatientImportConfigDataSuccessAction,
  editPatientImportConfigDataUpdateAPIMsgAction,
} from "./Actions";
import baseUrl from "../../../../Url";
import { headers } from "../../../../components/Utility";
import { setupInterceptorsTo } from "../../../Authentication/Interceptors";

let apiRes = {} as EditPatientImportConfigValueRes;
export const editPatientImportConfigData = (
  payload: EditPatientImportConfigDetailsBody
) => {
  return function (dispatch: Dispatch<EditPatientImportConfigDataActionTypes>) {
    dispatch(editPatientImportConfigDataLoadingAction(true));
    setupInterceptorsTo(axios)
      .post(
        baseUrl.baseUrl +
          `/patientapp/api/dataimport/edit_patient_import_config`,
        payload,
        {
          headers: headers,
        }
      )
      .then((res) => {
        apiRes = res.data;
        dispatch(editPatientImportConfigDataLoadingAction(false));
        dispatch(
          editPatientImportConfigDataSuccessAction(
            res.data,
            res.data.message !== undefined
              ? res.data.message
              : "Imported Config Data Edited successfully"
          )
        );
      })
      .catch((error) => {
        dispatch(editPatientImportConfigDataLoadingAction(false));
        dispatch(
          editPatientImportConfigDataErrorAction(
            {} as EditPatientImportConfigValueRes,
            error.response !== undefined
              ? error.response.data.message || error.response.data.detail
              : "Something went wrong",
            error.status !== undefined ? error.response.data.status || 0 : 0
          )
        );
      });
  };
};

export const updateEditEditPatientImportConfigDataAPIResMsg = () => {
  return function (dispatch: Dispatch<EditPatientImportConfigDataActionTypes>) {
    dispatch(
      editPatientImportConfigDataUpdateAPIMsgAction(
        apiRes as EditPatientImportConfigValueRes,
        "",
        "",
        0
      )
    );
  };
};

export const clearEditPatientImportConfigsDataAPIRes = () => {
  return function (dispatch: Dispatch<EditPatientImportConfigDataActionTypes>) {
    dispatch(
      clearEditPatientImportConfigDataAPIRes(
        {} as EditPatientImportConfigValueRes,
        "",
        "",
        0
      )
    );
  };
};
